<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western2" id="calibre_pb_8"><a id="Chapter02"></a>
Chapter 2</h1>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c6">Radiating, heart stopping pain woke me up. I was
sprawled out on a clammy cement floor. The air was rancid and
something dripped, splashing into a shallow puddle. Little droplets
of liquid splashed onto my face. My vision was too fuzzy to tell if
it was blood or water.</p>
<p class="western1">I took a deep breath and was hit with a
dizzying round of pain again. It took all the strength I had to
move my hand to my tender torso. I flinched when my hand touched my
ribs. I took a shallow breath and slowly sat up.</p>
<p class="western1">I couldn’t do it. I collapsed back down,
sending red hot hurt across my entire rib cage. I closed my eyes
and carefully touched each rib, certain that no less than two on
the right side were cracked if not completely broken. I could
barely breathe the pain was so intense.</p>
<p class="western1">I was shivering uncontrollably, which wasn’t
helping the situation at all. With my cheek pressed to the cold,
dirty floor, I concentrated on getting enough oxygen. After a
minute, I pushed myself up again. Every part of me screamed in
protest. What the hell had been done to me? I felt as if I had been
hit by a truck, thrown down a flight of stairs…or dragged through a
field and then into a mental hospital.</p>
<p class="western1">I opened my eyes. Yes, the latter was what
had happened. Vomit threatened to come up but was choked down by a
sob.</p>
<p class="western3">Rider.</p>
<p class="western1">I crawled to the front of the room, which
felt more like a cell. I assumed I was in some sort of solitary
confinement or holding area for psychotic and violent patients. I
heard the distant shuffle of feet and the murmur of hushed voices.
A rolling office chair and a stained coffee cup sat a few feet to
the right of the door, which was a combination see-through plastic
and metal. Candy wrappers littered the space around it.</p>
<p class="western1">A hand gun rested on the faded blue cushion
of the chair.</p>
<p class="western1">I desperately looked around for Rider.
Suddenly remembering that I might not be alone, I turned—a bad move
on my part. Pain hit me like a fist in the face. I doubled over,
feeling like I might really puke.</p>
<p class="western1">The shuffling of feet turned into footfalls
and the voices grew louder. I scuttled back to my spot on the floor
and lay down again.</p>
<p class="western1">“…took his weapons. He was still breathing
when we brought the bitch inside,” a gruff voice spoke.</p>
<p class="western1">“She put up a good fight, ‘eh? Heard she got
Pauly pretty good.”</p>
<p class="western1">“Hells yeah. Adrian—I mean Dre—will get a
kick outta her. What do we do with her until he gets back?”</p>
<p class="western1">“Kisha says to leave her be. And don’t mess
up her face. You know Dre likes ‘em pretty.”</p>
<p class="western1">The two men came to a stop in front of the
room, peering in through the door. I didn’t move a muscle. One of
them picked up the gun and pulled back the hammer, a sound I was
familiar with. He plopped heavily in the chair and the wheels
skidded back under his weight.</p>
<p class="western1">“Get off your ass, Joe!” the gruffer of the
two voices shouted. “You’re such a lazy piece of shit,” he
huffed.</p>
<p class="western1">“Get off it, Cutter!” Joe shifted his weight,
causing the chair to creak. “What’s she gonna do? She’s still
knocked out cold.”</p>
<p class="western1">Cutter laughed—it was deep and husky and
vile. “Yeah, I clocked her good.”</p>
<p class="western1">I made a mental note of that. I had no idea
how I’d do it, but I was going to crack Cutter’s skull until his
brain oozed out.</p>
<p class="western1">“Can we play with her?” Joe asked.</p>
<p class="western1">“I told you—leave her be! Dre should be back
in a few. Then we’ll decide.”</p>
<p class="western1">“Yeah,” Joe agreed.</p>
<p class="western1">“Don’t. Touch. Her,” Cutter reiterated.</p>
<p class="western1">“Fuck you, Cutter,” Joe jeered. “I can handle
my own shit.”</p>
<p class="western1">“We’ll see about that,” Cutter mumbled and
walked away. “Come on, we have to get that ginger prick’s body
before it attracts the biters.”</p>
<p class="western1">Thinking they had both left, I was just about
to look up when I heard the chair creak again. I didn’t want to
move until he was gone. But then what? I was locked in a maximum
security mental hospital. There was no way I could get myself out
of this.</p>
<p class="western1">Deciding it was now or never, I took a sharp
intake of breath as if I was just waking up. That, of course, hurt
like a motherfucker.</p>
<p class="western1">“Hey!” Joe dumbly yelled.</p>
<p class="western1">I slowly pushed myself up.</p>
<p class="western1">“Hey! Hey girl!” he shouted. “Are you
awake?”</p>
<p class="western1">I groaned and pushed myself up farther and
momentarily considered acting like I was waking up dead—as in
zombie dead. But that might have gotten me shot. I pulled myself to
my knees, the pain in my rib cage blinding. “No, I’m still asleep,
dipshit,” I sneered.</p>
<p class="western1">“About time you woke up. Lucky you got a
nap,” he told me, his voice muffled behind the closed door; the
sliding window in the center of the door was open. I wasn’t sure if
he was trying to be nice.</p>
<p class="western1">“Yeah, so <i class="calibre4">lucky</i>.”</p>
<p class="western1">I looked into the hall. Joe was no taller
than me, incredibly pale, very thin, and had a wispy blonde chin
strip of a beard that was grown out and banded together. His gray
eyes widened and his nostrils flared. He jumped up from the
chair.</p>
<p class="western1">“Calm your shit,” I spat, just to piss him
off. I had a nagging feeling he didn’t like being told what to
do.</p>
<p class="western1">“Watch your mouth,” he warned me.</p>
<p class="western1">“Or what, you’ll beat me up?” I glared at
him, swallowing the lump of fear in my throat.</p>
<p class="western1">“Just you wait. Wait till Dre gets back.
You’ll wish <i class="calibre4">beat</i> is all he does.”</p>
<p class="western1">“Yup. I’ll wait. I’m not going anywhere,
dumbass.” Insulting him made me feel less afraid. Really, it should
have been packing the fear into me. I had no idea what Joe was
capable of or if he was even sane. I wondered if I should reason
with him, let him know we are on the same side: living in this dead
world.</p>
<p class="western1">No. They shot Hayden that time we were
sitting on the tailgate—not far from the compound—and now Rider.
Tears pricked the corners of my eyes when I thought of them. I knew
Hayden heard the shot. He would come for me; I didn’t want him to,
but I knew he would. If he was lucky, Ivan held him back until they
came up with a plan. I hoped to God they had gotten to Rider in
time.</p>
<p class="western1">It was absolutely ridiculous to hold onto
that shred of hope. I wanted so desperately to believe that Rider
was going to pull through. I wanted to see his big smile, blue
eyes, and messy red hair again.</p>
<p class="western1">“Listen here,” Joe sneered and bent close to
the door. Before he could put the fear of God in me, he
straightened up and looked down the hall. “Anything?” he
shouted.</p>
<p class="western1">“No,” a female voice answered. “Just the red
head and the bitch. Fucking stupid, if you ask me. I don’t know
what the hell they were trying to accomplish. Doesn’t matter now, I
suppose.”</p>
<p class="western1">My heart skipped a beat and I had to remind
myself not to look up with a doe-eyed look. They hadn’t found
Hayden. He was still alive. And if he was still alive, then Rider
had a chance.</p>
<p class="western1">“This is her?” the woman asked. “I thought
she’d be bigger from how Cutter described her.” She leaned close to
the door and inspected me as if I was a zoo animal. I wished I was
able to run to the window with my teeth bared.</p>
<p class="western1">She smacked gum, chewing with her lips apart.
As she continued to look me over, I glanced at her as well. She had
on dark jeans that were a size too small; they squeezed her narrow
waist so much that skin spilled over the waistband. Her t-shirt was
cut so that it fell off her shoulder, and the ends were gathered
and balled up, held together with a scrunchy. Her hair baffled me;
half was in braids that ended in perfect spiral curls. Who the fuck
curled their hair when freaking zombies ran amuck?</p>
<p class="western1">Rainbow laces were loosely tied in her
high-top Converse shoes and gold bangle bracelets rattled from each
arm. She stood up and flicked her hair back, revealing large hoop
earrings as well. She couldn’t be older than twenty-one.</p>
<p class="western1">Her brown eyes lingered on me for a few more
seconds. Then she waved her hands and spun around. “Leave her be.
Once my Dre-Dre gets back, we’ll figure somethin’ out.”</p>
<p class="western1">“You’re the boss, Kisha.”</p>
<p class="western1">“Uh-huh,” Kisha replied, her words high
pitched at the ends like she was just so innocent. Without so much
as one look back, she walked down the hall. A moment later, Joe
followed.</p>
<p class="western1">I was alone as far as I could tell. I could
hear voices echoing through the hall, but I couldn’t make out a
word of what was being said. They steadily grew louder. I moved to
the front of the room and turned my head, only able to see their
shadows.</p>
<p class="western1">“You fucking retard!” someone yelled.</p>
<p class="western1">“It’s not my fault!” Cutter yelled back. “You
saw the way that bitch cut up Pauly. What was I supposed to do?
She’s the one we wanted, anyway.”</p>
<p class="western1">“You left someone behind!” the other guy
spat. “Dre’s not gonna be happy about this.”</p>
<p class="western1">“Dre won’t fucking know if you keep your
goddamn mouth shut!”</p>
<p class="western1">The other guy laughed. “You want to lie to
Dre?”</p>
<p class="western1">“That kid was shot! In the stomach. No way’s
he’s gonna recover from that!” I put my hands on the plastic door.
My heart sped up. They were talking about Rider. “He’s not a
threat!”</p>
<p class="western1">“Bullshit!” the other guy screamed. “How do
we know he didn’t run off to his buddies, huh? Tell them we took
their bitch? They’ll come after her, come after us! You fucked up,
Cutter. You and Pauly both. And I’m telling Dre.”</p>
<p class="western1">“No, you’re not,” Cutter threatened. I heard
the sound of a fist smacking into someone’s flesh. I pressed my
face against the window. Cutter leaned back and threw his arm
forward again. Whoever he hit fell. “It’s a shame,” he said as he
bent over and grabbed the guy by the ankles, “that the bitch shot
you before we could stop her.” He laughed and dragged the guy away.
A few seconds later, a gun fired, causing me to jump.</p>
<p class="western1">I pushed away from the bars. Holy shit.
Cutter just killed one of his own to save his ass. He terrified me
more than any zombie. My breath came out in ragged huffs.
Trembling, I put my hand over my mouth. Rider was alive. He had
gotten away. He had a chance!</p>
<p class="western1">I moved my hand from my mouth to my chest; my
heart was beating so fast it hurt. I forced myself to take a slow,
deep breath and winced from the pain. I closed my eyes and took
another. I moved away from the front of the room and began to feel
the panic of being trapped. I looked around for anything useful. An
uncomfortable bed was bolted to the floor. My eyes traced over the
four-point leather restraints. I clenched my teeth and whimpered in
defeat. There was nothing in here that could help at all.</p>
<p class="western1">I had been in jail once before and in juvie
twice. Though, I had never come close to a maximum security
hospital for the criminally insane. The chance for escape was low
for me with this one. I closed my eyes and thought about how bad my
ribs hurt. I was terrified and thinking about the pain distracted
me from my fear.</p>
<p class="western1">It didn’t last long, however. The image of
Hayden’s face lingered in my memory. I hated that he was worrying
about me. I hated what he had to be going through.</p>
<p class="western1">“…no, I’ll be fine. She’s locked up, you
dumb-bo,” Kisha told someone, her voice gradually growing loud
enough for me to hear. I took a shaky breath and waited.</p>
<p class="western1">“Hi <i class="calibre4">Hayden</i>,” she said in a girly voice
and sat in the rolling chair. My heart skipped a beat at the sound
of his name. Hayden? How did she know about Hayden? Oh my God—they
must have gotten him too! My hand flew to the dog tags that hung
around my neck. Oh, right. <i class="calibre4">Idiot,</i> I thought, <i class="calibre4">she thinks
I’m Hayden.</i></p>
<p class="western1">“I’m Kisha. So, you stumbled upon our hide
out. How did you get here?”</p>
<p class="western1">“I walked,” I said simply.</p>
<p class="western1">She laughed and the sound was like wind
chimes. “Duh! Where did you come from?”</p>
<p class="western1">“Kentucky.”</p>
<p class="western1">“Wow! You walked all the way from
<i class="calibre4">Kentucky</i>?” she asked, trying to pronounce the state’s name
in a southern accent.</p>
<p class="western1">“Yup.”</p>
<p class="western1">“Where are your friends?” she asked and
dropped some of her charm.</p>
<p class="western1">“Dead,” I said bitterly.</p>
<p class="western1">She laughed again. “Come on, Hayden, we don’t
have to be like this. We’re just talkin’, ya know, like girls
do.”</p>
<p class="western1">I glared at her.</p>
<p class="western1">“So,” she pressed. “Tell me straight. Where
are your friends? Do they know you’re here?”</p>
<p class="western1">“They did. But they’re dead now.” My heart
beat in my throat. I looked up, refusing to cry. I needed to hold
it together.</p>
<p class="western1">“Where did you two get your guns? You both
had big machine guns, right?”</p>
<p class="western1">“We found them.”</p>
<p class="western1">“Mh-hm,” she muttered. “You’re in the army,”
she began, and I resisted the urge to roll my eyes and correct her.
“So are you <i class="calibre4">sure</i> you just found them? The government didn’t
supply you with guns?”</p>
<p class="western1">“Yes, the government gave us each a single
machine gun and sent us on our merry way,” I spat dryly.</p>
<p class="western1">She narrowed her eyes, glared and me, and
sighed. “You’re gonna be a fun one, aren’t ya?”</p>
<p class="western1">When I didn’t say anything in response, she
continued drilling me. “Come on now and just tell the truth. It
will make it easier on you.” She flashed a sickening smile. Though
her lips curved up, her eyes remained dark and void of emotion.
“Who are you?”</p>
<p class="western1">“Just a small town girl,” I calmly
stated.</p>
<p class="western1">One of her eyebrows shot up and she leaned
back. “Uh, ok. And how did you get here?” she asked again, as if
asking me the second time would make me suddenly tell the
truth.</p>
<p class="western1">I tipped my head up and looked into her eyes,
keeping my face neutral.</p>
<p class="western1">“How did you get here?” she repeated, her
tone darker.</p>
<p class="western1">“We wandered,” I sighed. “We went anywhere
just trying to escape the zombies.”</p>
<p class="western1">She leaned back in the chair. “I see. And you
just thought you could move in on our set up?”</p>
<p class="western1">“Of course not; there were only two of us.” I
took a jagged breath. “Listen, Kisha. I think this is a
misunderstanding. We had no intentions on moving in or whatever. As
far as I’m concerned, there are only two teams right now: dead and
alive. Seeing that we are both alive, I think something can be
worked out, don’t you?” I reasoned.</p>
<p class="western1">She huffed, flipped her hair, and crossed her
arms. “Outsiders are threats. We’re fine without you.”</p>
<p class="western1">“Then let me go. I’m just one girl; I can’t
do any damage,” I pleaded.</p>
<p class="western1">“We’re not done with you…yet,” she
threatened. She cast me one more telling glance before getting up
and striding down the hall. I got up and thoroughly searched the
seclusion cell, knowing it was a moot point since it was a
<i class="calibre4">cell</i> after all. I walked back and forth, trying to will the
stiffness out of my body.</p>
<p class="western1">It was my damn injured ribs that hindered me.
I couldn’t take a deep breath, straighten up, or twist my torso
without pain crippling me. And I was so incredibly thirsty to the
point of feeling sick.</p>
<p class="western1">Feeling hopeless, I sat on the hard bed and
tried to come up with a plan. Maybe I could fake the extent of my
injuries to get some sort of medical attention. I planned to punch
whoever came in to look at me hard in the throat so he couldn’t
call for help and slam his head into the cement walls at least
twice before making a break for it.</p>
<p class="western1">Then I’d no doubt run into a closed door or a
locked hall…or get shot.</p>
<p class="western1">Dammit.</p>
<p class="western1">I just didn’t see a way out for me unless I
reasoned and bartered…and that plan didn’t seem too promising
considering I had just witnessed Cutter plunge a knife into someone
he knew with no hesitation. Slowly, I rose from the bed and walked
to the front of the room. My fingers wrapped around the cool,
sticky metal that lined the small window. For good measure, I gave
it a shake. As expected, the door didn’t so much as budge.</p>
<p class="western1">I looked for the lock and was confused for a
few seconds when I didn’t find it. Then I remembered Brock saying
that this facility was rather new; everything was no doubt
controlled electronically now, as was almost everything before the
outbreak. The only ‘key’ was inside some sort of electrical device.
Hell, maybe there was even an app for it.</p>
<p class="western1">I ran my hands through my hair and took
careful deep breaths, unable to keep Hayden off my mind. I wanted
to look into his hazel eyes, to hear him laugh, to feel his touch
on my skin. I wanted to hold him and tell him I loved him.</p>
<p class="western1">Hours passed and I couldn’t sit any longer. I
got up and paced around the cell, ignoring the pain every breath
caused. My throat was beginning to burn from being so dry. My
stomach grumbled with hunger, though I didn’t think I’d be able to
eat if a feast was laid out in front of me.</p>
<p class="western1">Voices floated down the hall. Angry voices;
it sounded like two men arguing. The identifiable sound of someone
getting a fist to the face made me jump. Someone whistled and the
sound of pounding feet echoed through the dark hall. I moved to the
front and pressed my cheek against the door.</p>
<p class="western1">The fuzzy outlines of three men became
visible. Only two were walking, the third was being dragged.
Ignoring my stares, the guys pulled the body in front of the room
across from mine. One of the men let go of the unconscious man’s
hand, which smacked against the concrete floor with a thud. He
hurried off down the hall to press the button on whatever
controlled the locks.</p>
<p class="western1">The door clicked open, and the body was
deposited inside.</p>
<p class="western1">“Let him rot,” one of the men grumbled.</p>
<p class="western1">“Traitor,” the other spat. They cast curious
looks at me but walked away. I put a hand on the door frame and
peered across the way. His back was to me, so I couldn’t see his
face.</p>
<p class="western1">“Hey,” I said quietly. “Knocked out cold,” I
speculated when the man didn’t respond. I shook my head and plodded
back to the metal bed. I stared straight ahead and tried not to
panic. Forcing myself to remain calm, I counted to one hundred. As
soon as I began to count backwards, the guy groaned. I watched,
waiting for him to come to.</p>
<p class="western1">Slowly, he sat up, rubbed his head, and
looked around. He let out a heavy sigh of annoyance, as if waking
up in a seclusion room was something he’d done before. He stood and
stepped close to the see through bars. The dim hallway light
illuminated his face. Dark brown eyes peered at me curiously. He
had a mess of black hair and tan skin. I wasn’t expecting him to be
so young—or so attractive.</p>
<p class="western1">“Hey,” he finally responded. “You’re the girl
they found?”</p>
<p class="western1">“Define found,” I said back cattily.</p>
<p class="western1">He laughed and flashed a white smile. “Yeah,
the boys are a little, uh, unorthodox, I suppose.”</p>
<p class="western1">“Yeah,” I agreed.</p>
<p class="western1">“I’m Carlos,” he introduced.</p>
<p class="western1">“Hayden,” I said, sticking with the lie. “Why
are you in here?” I blurted.</p>
<p class="western1">“Long story,” he chuckled.</p>
<p class="western1">“I’m not going anywhere. And neither are
you,” I pointed out.</p>
<p class="western1">“Right, right. Why am I here? Originally it
was for depression. I overdosed twice but passed out before I took
enough to kill myself. But I’m <i class="calibre4">here</i> because I want out.”</p>
<p class="western1">“Out?” I asked, swallowing my pounding
heart.</p>
<p class="western1">“Yeah, out.”</p>
<p class="western1">“Why can’t you leave?”</p>
<p class="western1">“Oh, I can leave,” he told me. Seeing my
confusion, he continued. “Leaving is suicide,” he laughed. “But I
don’t want to die anymore. I got no support out there. There’s no
way I’ll make it. I want to leave the gang; I wanted to before all
hell broke loose.” He leaned on the bars and laughed. “I was
supposed to get out a month after the first guy went crazy.”</p>
<p class="western1">“Get out?” I asked, and then suddenly
realized that Carlos had never left in the first place. He had been
a patient. And if he was admitted, then the others probably had
been too. It made sense, now that I thought about it. And most
likely they were insane and dangerous and had been locked up for a
reason…</p>
<p class="western1">The maximum security factor suddenly seemed
favorable. It kept dangerous people in, and it would keep dangerous
people out, but what had happened to the guards, doctors, and
nurses? How did Dre come into power?</p>
<p class="western1">“Yeah,” Carlos answered. “I started new meds
that really helped with the depression. I was gonna get my GED, go
to college, and make a life for myself. My uncle was gonna let me
move in with him up in Jersey. A fresh start, ya know?”</p>
<p class="western1">“I do,” I told him.</p>
<p class="western1">“I thought I was lucky,” he said with a
laugh. “When we figured out what happened, we thought we were safe
in here. And I already had a spot in his gang.” He shook his head.
“I should have known better.” He sighed and looked across the hall.
“What’s your story?” he asked, tipping his head back a bit.</p>
<p class="western1">My story? My story was that I had left the
safety of our compound with four of my friends in search of
supplies and survivors. We were in a ransacked house when a vintage
black Mustang drove past, one we recognized as belonging to the
people who shot Hayden a few months ago. We followed it here; Rider
and I spilt from the group to get a closer look. Then we were
ambushed, attacked, and I woke up in here. My heart broke thinking
of Hayden. I hated being separated from him. “My friend and I were
looking for survivors. We saw tire tracks and followed them.”</p>
<p class="western1">“You have a camp?” he inquired.</p>
<p class="western1">I shook my head. “No. We’re always on the
move.”</p>
<p class="western1">He narrowed his eyes. “You look too well fed
to be on the move. I’ve seen my fair share of drifters, even before
shit hit the fan. You’re from a camp.”</p>
<p class="western1">“Why do you care?” I spat.</p>
<p class="western1">“Oh, I don’t. <i class="calibre4">They</i> do,” he whispered.
“Listen,” he said with urgency. “Whatever you do, don’t—”</p>
<p class="western1">He cut off when someone came down the hall.
The man who called himself Cutter stopped in front of my door.</p>
<p class="western1">“The girl doesn’t know anything,” Carlos said
quickly. “I already questioned her.”</p>
<p class="western1">“Fuck off,” Cutter said over his shoulder.
“Why would I trust her, and why would I trust <i class="calibre4">you</i>, traitor?”
he jeered. I caught a glimpse of Carlos’s face; his dark eyes were
full of pity.</p>
<p class="western1">Oh shit.</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c">* * *</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1">“Unlock it!” Cutter yelled. The door clicked
open. He held up a knife, weak light shining off the silver blade.
“Don’t even think about it,” he taunted. “Get up.”</p>
<p class="western1">I stood quickly, grimacing in pain. Knowing
this was going to hurt, I took a breath and braced myself. The
moment Cutter stepped into my cell, I dropped and spun, kicking my
leg out and knocking him off his feet. I scrambled up, moving
slower than I wanted to. I kicked his right hand, sending the knife
skidding out of the room and across the hall, sliding under the
door to Carlos’ room. He grabbed it before Cutter even noticed what
had happened.</p>
<p class="western1">My body doubled over in pain. Cutter sprang
to his feet, grabbed a fistful of my hair, and yanked me up. With
his other hand, he hit the side of my head. I sank to the ground,
my vision fuzzy. Heavy hands grabbed my shoulders and flipped me
over. He pinned me down, straddling me.</p>
<p class="western1">“Keep struggling, hot stuff. It feels good
when you squirm.” His fist hit my face once more before he took a
handful of my hair. “You like that, bitch?” he jeered. He yanked my
head up, and I cried out. I planted my hands on the ground and
raised my right leg, kneeing him in the back. He fell across me.
Searing pain webbed across my rib cage. I clasped my hands around
his face and dug my fingernails into his skin. Cutter rolled off of
me.</p>
<p class="western1">“Cutter!” someone shouted. “What’s going on
in there?”</p>
<p class="western1">Cutter froze, knowing he wasn’t supposed to
hurt me. His eyes met mine for a millisecond before he backed
off.</p>
<p class="western1">“Nothing!” he yelled. “Bitch took a swing at
me, that’s all.”</p>
<p class="western1">“Cutter!” a high pitched voice screamed.
“What the hell are you doing in there?” Kisha’s voice grew louder
as she moved down the hall. “Bring her here!” she ordered.
“Now!”</p>
<p class="western1">“Yes, ma’am,” Cutter replied. He moved to
grab me; I shied away. “You’ll pay for this,” he threatened and hit
me once more, knocking me out.</p>
<p class="western1">When I came to, I was sitting in a chair. My
arms and legs were strapped down. I had a horrible ringing in my
ears and a pounding headache.</p>
<p class="western1">“Hi, Hayden,” Kisha said with fake charm, her
voice as irritating as nails on a chalk board. I blinked and looked
around the room; it was dimly lit and empty except for the chair I
was sitting in, a table, and two chairs on its other side. Through
a window, I saw that daylight had vanished. Knowing that hours had
passed since I had last seen my friends made my stomach flip-flop
with nerves. I wanted out. I needed out.</p>
<p class="western1">“Glad you finally woke up,” she sneered,
crossing her arms to show off the gun she had tucked into an ugly,
overly-bedazzled jacket. “I have a few questions for you. If you
answer like a good girl, everything will be fine.”</p>
<p class="western1">I didn’t open my mouth to spit back a
sarcastic remark. Instead, I tried to keep breathing. Cutter leaned
over me, grinning. He placed his hand on my cheek and exhaled. His
breath smelled like stale cigarettes. He let his hand fall, his
fingers trailing down my neck and caressing my collar bone. I
shivered in disgust.</p>
<p class="western1">He laughed and leaned in closer. With his
face inches from mine, he parted his lips. And I head butted him.
He recoiled; one hand flew to his nose and the other landed hard on
my face.</p>
<p class="western1">“Bitch!” he yelled and raised his fist.</p>
<p class="western1">“Cutter!” Kisha yelled. “What are you
doing?”</p>
<p class="western1">Cutter snarled at me, exhaled, and lowered
his hand.</p>
<p class="western1">“Save it,” Kisha said in a level tone. Her
dark eyes met mine and her mouth curved into a wicked smile.
“Come,” she ordered Cutter, who took a step back. He looked away
and then jumped at me again, trying to scare me. I set my face and
glowered at him.</p>
<p class="western1">He flicked off the lights when he left the
room. Totally in the dark, I couldn’t see anything. I kept my eyes
focused on what I thought was the doorway, but I was soon seeing
gray shapes moving around the room that I knew only existed in my
head.</p>
<p class="western1">I jerked my arms, causing the leather straps
to cut into my skin. The arms of the chair weren’t going to break
easily. I planted my feet on the ground, grabbed the arms of the
chair, and tried to stand. The legs wiggled slightly, but were
bolted to the floor. I repeated the effort again and again, until I
was out of breath. I exhaled and was reminded of my broken ribs.
The chair had loosened; I could probably break it free with one
more tug…once I could breathe again.</p>
<p class="western1">I shook my head. How was I going to get out
of this one? If every breath hurt, could I really run to
safety?</p>
<p class="western1">“Maybe,” I said aloud. My sophomore year of
high school I dated Cory Thomas, the starting quarterback for our
school’s football team. He was tall, blonde, and two years older
than me. My stepdad Ted did not approve. Three days before the
homecoming game, Cory broke several ribs during practice. But he
played, and played well. He ended up in the hospital after the
game, though.</p>
<p class="western1">If he could push past the pain for the sake
of a stupid football game, then I could do it for my life. I nodded
in the dark. I had to do it.</p>
<p class="western1">Rider’s face flashed across my mind; I had
more than just my life to fight for. I wanted revenge.</p>
<p class="western1">Footfalls echoed through the empty hall. I
swallowed any doubt and straightened up. Rage fueled my weak body.
A cone of light from a flashlight illuminated the door. The person
carrying it stopped and shut it off. A second later, the lights
flicked on. I blinked and my eyes tried to adjust.</p>
<p class="western1">“Wakey-wakey!” Kisha cooed. A man I assumed
to be Dre followed her in. He was my height, but muscular. Tattoos
and scars covered his tan arms. His head was shaved clean and a
thin beard covered the bottom half of his face.</p>
<p class="western1">“Hi, Hayden,” he said to me, his eyes
glinting with pleasure when he spoke my name, as if he expected me
to be surprised.</p>
<p class="western1">I raised an eyebrow and leaned back in the
chair.</p>
<p class="western1">“I’m Dre. I run this place. I got people to
take care of. Ya understand, right?”</p>
<p class="western1">I pressed my lips together and didn’t
respond.</p>
<p class="western1">Dre sighed dramatically and cracked his
knuckles. “We can’t risk strangers walking into our camp, ya
know?”</p>
<p class="western1">Yes, I did know. And I agreed. But I’d be
damned to tell him that.</p>
<p class="western1">“So,” he continued. “I’ve got some questions
for you.” He walked behind my chair; my nerves tingled because I
could no longer see him. “Where did you come from?”</p>
<p class="western1">“Kentucky,” I said shortly.</p>
<p class="western1">“Is your camp there?”</p>
<p class="western1">“I don’t have a camp,” I told him.</p>
<p class="western1">Dre put a hand on my shoulder. “Yes, you do.
Where is it?”</p>
<p class="western1">“I don’t have a camp,” I repeated.</p>
<p class="western1">Kisha’s eyes widened and she smiled, watching
Dre. My heart beat faster.</p>
<p class="western1">“Where is your camp?” he asked again, saying
each word slowly.</p>
<p class="western1">“I don’t have a camp,” I said for the third
time. Dre walked around me, his fingers sliding down my arm. He
held something in his other hand and a flicker of fear ran through
me when I recognized the taser. Dre turned it on and pressed a
little black button. A blue line of electricity zapped from the
prongs.</p>
<p class="western1">“Tell me where your camp is,” he said through
clenched teeth and let go of the button.</p>
<p class="western1">“I don’t have a camp,” I said flatly, feeling
like a broken record.</p>
<p class="western1">He pressed the taser to my abdomen.</p>
<p class="western1">“Yes you do.”</p>
<p class="western1">The jolt of electricity shocked through my
body and continued to tingle after Dre released the taser.</p>
<p class="western1">“Thing is, <i class="calibre4">Hayden</i>, my boys have now
shot two of your friends.”</p>
<p class="western1">My blood ran cold. I struggled to keep my
face neutral. “I don’t know what you’re talking about,” I said.</p>
<p class="western1">He pressed the taser to my skin again, his
finger hovering over the button. My body tensed as I waited for the
shock. “Yes you do. You think we’d forget a pretty face like this?
You have a camp.” He took a step back and crossed his arms. “You
have food. You have weapons. You have that truck with the gun
mounted in the back.”</p>
<p class="western1">I shook my head, feeling like I was sinking
in frigid water. “No, I don’t. You’re thinking of someone
else.”</p>
<p class="western1">Dre laughed, put the taser in a pocket of his
baggy jeans, and hit me—his fist smacking into the same spot where
Cutter had hit me. The pain made me nauseous.</p>
<p class="western1">“Tell me where the camp is. I know you have
one. Some of your other friends went after my boys.”</p>
<p class="western1">Fuck. They did. And they killed two and
injured another. “No,” I told him defiantly.</p>
<p class="western1">He hit me again. “Listen, bitch, you tell me
where the camp is or—”</p>
<p class="western1">“Or what?” I interrupted. “You’ll kill
me?”</p>
<p class="western1">“You’ll be begging for death.”</p>
<p class="western1">I rolled my eyes. “Oh, please. Seen enough
cheesy mob movies? If you’re gonna threaten me, at least make them
original. I bet Bubba the executioner is on his way with a big bag
of knives, am I right?”</p>
<p class="western1">The only answer I got was Dre’s fist landing
on my forearm and the taser pressing into my right shoulder.</p>
<p class="western1">“Last chance—tell me where the camp is!” Dre
demanded.</p>
<p class="western1">I forced myself to keep from screaming. “No.
Kill me…and then you’ll never know.”</p>
<p class="western1">Dre let out a breath and stared at me.
Waiting for his next move was almost as bad as being beaten.
Finally, he stood, walked over to Kisha, and took something from
her. A wicked smile revealed Dre’s yellowed teeth. He turned
around, holding up a large knife. Fear swelled in my heart.</p>
<p class="western1">“Time for some fun,” he leered. Part of my
brain screamed to just make up some lie to halt the torture. I was
positive this wasn’t going to end well no matter what I told them.
I had to hold out as long as I could. I had something they needed;
I hoped they wouldn’t kill me just yet. Hayden would do something;
that I was sure of.</p>
<p class="western1">Dre rested the tip of the knife on my arm.
“Let’s make this simple,” he began. “Do you have a camp?”</p>
<p class="western1">“You already said you knew the answer to that
one, asshole,” I retorted.</p>
<p class="western1">Dre added pressure to the knife. I watched
the blade push down my skin. “Where is your camp?”</p>
<p class="western1">“I never was good with directions,” I told
him innocently. The blade punctured my skin. A cry escaped my lips
and a tiny bead of blood surfaced.</p>
<p class="western1">“Where is it?”</p>
<p class="western1">“I’m drawing a blank. All those blows to the
head must have messed with my memory.”</p>
<p class="western1">Dre dragged the knife down my arm, slowly
tearing my skin. I couldn’t help but cry out again. Blood dripped
to the floor.</p>
<p class="western1">“Tell me,” he demanded. I curled my lips over
my teeth and kept my mouth shut. Dre put the tip of the knife into
the cut and pushed down. I screamed when he dragged it through my
broken skin. He asked me where the camp was again and repeated the
horrible process of deepening the wound. He moved behind me and put
a hand on my shoulder.</p>
<p class="western1">“I’m not playing around,” he warned. He
raised the knife to my throat. “Tell me where the camp is or I’ll
slit your throat.”</p>
<p class="western1">“Go ahead and do it,” I tried to snarl, but
my voice faltered. My body hurt and tears blurred my vision.</p>
<p class="western1">“Just do it!” Kisha encouraged.</p>
<p class="western1">“Not yet,” Dre scolded.</p>
<p class="western1">I closed my eyes, tears rolled down my
cheeks, and I let out a breath. My hands were shaking
uncontrollably. I pressed them on the arms of the chair. Blood
spilled from the gash in my left arm.</p>
<p class="western1">Dre let the knife clatter to the floor,
splattering my blood on the white tile and knelt down in front of
me. “You’re gonna wish I had killed you, you stupid cunt.”</p>
<p class="western1">“I’ll kill myself,” I threatened. “With the
blood loss it won’t be hard.” I looked at my bleeding arm and then
back at Dre.</p>
<p class="western1">Angered, he grabbed the taser and pressed it
against my neck. My hair blocked some of the shock. Still, the
electricity shot through my body and I thought I was going to have
a heart attack. I let my eyes roll back and my head drop.</p>
<p class="western1">Dre pulled the taser back and stood.</p>
<p class="western1">“Did you kill her?” Kisha asked, her voice
shrill.</p>
<p class="western1">Dre’s fingers pressed against my neck. “No.
She’s alive. Just knocked out.” I heard feet scuffle away. I opened
one eye and saw that Dre was a few feet in front of me with his
back turned. Heart racing, I wrapped my hands around the arms of
the chair. I pressed my feet on the ground and sprang up.</p>
<p class="western1">The bolts didn’t snap like I had hoped. Kisha
screamed and Dre whirled around. He advanced on me fast and his
eyes brimmed with insanity.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_0a9fca13b620a2de592dddca89bae7c7_34PU7E.ch.fixed.fc.tidied.stylehacked.xfixed_split_009.vue?5db21e91